import React from 'react'
import Collapse from '@mui/material/Collapse';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Link from '@mui/material/Link';

import "./DevWarning.css"

export default function DevWarning() {

  const [openCollapse, setOpenCollapse] = React.useState(true);



  return (
    <>
      <Collapse in={openCollapse}>
        <Alert severity="info" variant="outlined" onClose={() => {setOpenCollapse(false)}}>
          <AlertTitle>Diese App befinden sich in entwicklung.</AlertTitle>
          Möglicherweise treten Fehler auf oder Daten werden falsch dargestellt. 
          In dem du Fehler meldest und Feedback gibst, trägst du zur weiterentwicklung dieser App bei.
          <br/>
          <Link href="https://forms.gle/m54MiPtkA8ZqDFgP8" target="_blank" className='LinkToForm'>Fehler melden</Link>
          <Link href="https://forms.gle/tC3SaYYVgSS3W8y99" target="_blank" className='LinkToForm'>Feedback geben</Link>
        </Alert>
      </Collapse>

    </>
  )
}
